/**
 * バージョンTOPへの遷移先パスを組み立てる。
 */
export const buildVersionTopPath = (
  organizationId: string,
  versionId: string
): string => `/organizations/${organizationId}/versions/${versionId}`;

/**
 * バージョンを開くときの遷移先パスを組み立てる。
 * initialViewId があればそのビュー、未設定ならバージョンTOPを指す。
 */
export const buildVersionEntryPath = (
  organizationId: string,
  versionId: string,
  initialViewId: string | null | undefined
): string =>
  initialViewId
    ? `${buildVersionTopPath(organizationId, versionId)}/views/${initialViewId}`
    : buildVersionTopPath(organizationId, versionId);
